import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    name: PropTypes.string
  };

  state = {
    error: false
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error: true });
    // if (process.env.NODE_ENV !== 'production') {
    //eslint-disable-next-line no-console
    console.error(
      `❌ Caught in "${this.props.name}" error boundary. ❌ \nThis is most likely an issue with your code  \n\n`,
      error,
      `\n\n Component Stack:`,
      errorInfo.componentStack,
      errorInfo
    );
    // }
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    return <div style={this.props.style} />;
  }
}
